<template>
  <el-row class="modify-record-inside">
    <el-col :span="24" class="modify-record-info">
      <div class="left">
        <span class="first">修改记录</span>
      </div>
    </el-col>
    <el-col :span="24" class="modify-record-content-area">
      <el-row class="modify-record-header">
        <el-col :span="2">句段</el-col>
        <el-col :span="8">原文</el-col>
        <el-col :span="8">译文</el-col>
        <el-col :span="2">编辑时间</el-col>
        <el-col class="last" :span="2">编辑者</el-col>
        <el-col class="last" :span="2">操作</el-col>
      </el-row>
      <div class="modify-record-wrap infinite-list-item">
        <div class="modify-record-content" v-for="(item , index) in getModifyRecordList"
             :key="`${index}-$(item.id)`"
             :class="{'last-content': ((getModifyRecordList.length)===(index+1)&&((getModifyRecordList.length)>=2))}">
          <el-col :span="2" class="item_index">
            {{getModifyRecord(item) || (index+1).toString().padStart(2, '0')}}</el-col>
          <el-col :span="8" class="item_file" :class="targetRightViewClass('source')"
                  v-html="((item.sourceSent) || '-')" />
          <el-col :span="8" class="item-special" :class="targetRightViewClass('target')">
            <span class="modify-record-target-wrap"
                  v-for="(targetItem,index) in getModifyTarget(item)" :key="index"
                  v-html="targetItem.data"></span>
          </el-col>
          <el-col :span="2" class="item_file">{{item.createTime}}</el-col>
          <el-col :span="2" class="item_file name">{{item.creatorName}}</el-col>
          <el-col :span="2" class="item_file name"><el-button type="primary"  size="small" @click="handleRecover(item)">恢复</el-button></el-col>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: "ModifyRecord",
  data () {
    return {
      value: '选项1',
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE
    };
  },

  computed: {
    ...mapGetters('editor', [
      'getUrlInfo'
    ]),
    //不使用用辅助函数的获取数据
    getModifyRecordList: function () {
      let modifyRecordInfo = this.$store.getters['editor/getModifyRecordInfo'];
      if ((Reflect.has(modifyRecordInfo, 'result')) && !!(modifyRecordInfo.result)) {
        return (modifyRecordInfo.result);
      } else {
        return []
      }
    },
    //获取修改记录的序号
    getModifyRecord () {
      return function (row) {
        if (!!row && !!(row.sentId)) {
          let taskContentList = (this.$store.getters['editor/getTaskContentList']);
          let indexSent = 0;
          if (!!taskContentList && !!(taskContentList.transSentRespVoList)) {
            (taskContentList.transSentRespVoList).every((item, index) => {
              if (parseInt(row.sentId) === parseInt(item.id)) {
                indexSent = (index + 1);
                return false
              } else {
                return true
              }
            });
            return indexSent.toString().padStart(2, '0')
          }
        }
      }
    },

    //获取修改痕迹的译文
    getModifyTarget () {
      return function (row) {
        let targetAtoms = Array();
        if (row && Reflect.has(row, 'targetSent') && !!(row.targetSent)) {
          let targetSent = JSON.parse(row.targetSent);
          if (targetSent && Reflect.has(targetSent, 'fragments') && !!(targetSent.fragments)) {
            let targetFragments = (targetSent.fragments);
            if (targetFragments && !!(targetFragments.length) && (Reflect.has(targetFragments[0], 'atoms')) && !!(targetFragments[0].atoms)) {
              targetAtoms = (targetFragments[0].atoms);
              // console.log(targetAtoms)
              let arr = [];
              arr = targetAtoms.filter(item => {
                return item.dataType === "text"
              })
              // console.log(arr, "arr");
              return arr;
            }
          }
        }

      }
    }
  },

  mounted () {
    // @scroll="handleScroll"
    // 页面注册滚动事件
    // let dom = document.getElementsByClassName("el-tabs__content")[0];
    // dom.addEventListener('scroll', this.handleScroll)
  },

  methods: {
    /**
    * @desc 特殊语种样式处理
    * @param {source} 源语言/目标语言
    * @returns {string} 返回样式类名
    */
    targetRightViewClass (source) {
      const { sourceLang, targetLang } = this.getUrlInfo
      if (source === 'source') {
        return this.SPECIAL_LANGUAGE.indexOf(sourceLang) !== -1 ? 'right-view' : ''
      } else if (source === 'target') {
        return this.SPECIAL_LANGUAGE.indexOf(targetLang) !== -1 ? 'right-view' : ''
      }
    },
    //恢复
    handleRecover(item){
      console.log(JSON.parse(item.tagTargetSent).fragments[0]);
      let params={
          content:'',
          costTime:0,
          fileId:item.transFileId,
          isAfterRevision:0,
          isCommitVersion:0,
          isSaveVersion:0,
          leaveMarkModel:0,
          sentId:item.sentId,
          sourceTagFragmentVo:{
            atoms:JSON.parse(item.tagSourceSent).fragments[0].atoms,
            sort:JSON.parse(item.tagSourceSent).sort,
            text:null,
            type:null
          },
          targetTagFragmentVo:{
            atoms:JSON.parse(item.tagTargetSent).fragments[0].atoms,
            sort:JSON.parse(item.tagTargetSent).sort,
            text:null,
            type:null
          },
          status:item.status,
          transModel:0,
        }
      if(this.getUrlInfo.type =='task'){
        params.taskId = this.getUrlInfo.taskId
        params.taskType = this.getUrlInfo.taskType
      }
      // return
      let paramsInfo ={
        params,
        type:1,
      }

      this.$store.dispatch("editor/updateTargetInfo", paramsInfo)
    }
    //   // 滚动事件-触底加载分页数据
    //   handleScroll: _.debounce(function (e) {
    //     //变量scrollTop是滚动条滚动时，距离顶部的距离
    //     let scrollTop = e.target.scrollTop;
    //     //变量windowHeight是可视区的高度
    //     let windowHeight = e.target.clientHeight;
    //     //变量scrollHeight是滚动条的总高度
    //     let scrollHeight = e.target.scrollHeight;
    //     //滚动条到底部的条件
    //     console.log("触底")
    //     if (parseInt(scrollTop + windowHeight) + 10 >= scrollHeight) {
    //       //写后台加载数据的函数
    //       // console.log("触底")
    //       // console.log("触底加载更多的数据:距顶部" + scrollTop + "可视区高度" + windowHeight + "滚动条总高度" + scrollHeight);
    //       let params = (this.$store.getters['editor/getModifyRecordParamsInfo']) || {};
    //       Reflect.set(params, 'partIndex', (++(params.partIndex)));
    //       let fileId = 0;
    //       let urlInfo = this.$store.getters['editor/getUrlInfo'];
    //       if ((urlInfo.type) === 'project') {
    //         let fileInfo = this.$store.getters['editor/getFileInfo'];
    //         fileId = (fileInfo.id);
    //       } else if (((urlInfo.type) === 'task') || ((urlInfo.type) === 'school')) {
    //         let fileTaskInfo = this.$store.getters['editor/getFileTaskInfo'];
    //         fileId = (fileTaskInfo.fileId);
    //       }
    //       Reflect.set(params, 'transFileId', fileId);
    //       Reflect.set(params, 'transProjectId', (urlInfo.projectId));
    //       this.$store.dispatch('editor/setModifyRecordInfo', params)
    //     }
    //   }, 1000, {
    //     'leading': true
    //   }),
  }

}
</script>

<style lang="less" scoped>
@import "assets/style.less";
</style>